import React from "react";
import SearchIcon from "../assets/images/search-icon.svg";

const PoreAnalysisZone = ({ zones = [] }) => {
  return (
    <div className="bg-white py-5">
      <div className="flex items-center gap-2 mb-4">
        <img src={SearchIcon} className="w-6 h-6" alt="" />
        <h3 className="text-base font-medium text-primary">
          Pore Analysis by Zone
        </h3>
      </div>

      <div className="grid grid-cols-4 gap-4 w-full">
        {zones.map((zone, index) => (
          <div key={index} className="bg-[#F8F8F8] p-4 rounded-lg text-center">
            <h4 className="text-sm font-medium text-primary mb-2">
              {zone.label}
            </h4>
            <div className="inline-block bg-black text-white text-xs font-semibold px-3 py-1 rounded-full mb-1">
              {zone.severity}
            </div>
            <p className="text-xs text-black/80">{zone.confidence}% conf.</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PoreAnalysisZone;
